import * as React from 'react';
// eslint-disable-next-line import/no-unresolved
import { useLocation } from '@reach/router';

import Icon from '@components/utils/IconWrap';

// Renders the social media icons and search icon
const IconLink = props => {
  const { url, name, icon, colorTheme } = props;

  const getColorClasses = () => {
    switch (colorTheme) {
      case 'blue':
        return 'text-blue-100 ring-offset-primary-dark';
      case 'cyan':
        return 'text-cyan-100 ring-offset-cyan-700';
      case 'purple':
        return 'text-violet-100 ring-offset-violet-700';
      default:
        return '';
    }
  };

  return (
    <a
      href={url}
      target="_blank"
      className={`${getColorClasses()} hover:text-white focus:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-white`}
      title={name}
      rel="noreferrer"
    >
      <span className="sr-only">{name}</span>
      <div className="h-6 w-6 transition ease-in-out duration-150">{icon}</div>
    </a>
  );
};

export default function ContactSectionForm(props) {
  const { form, hubspotForm, colorTheme } = props;

  const { pathname } = useLocation();

  console.log(pathname);

  const getBackgroundColor = () => {
    switch (colorTheme) {
      case 'blue':
        return 'bg-primary-dark';
      case 'cyan':
        return 'bg-cyan-700';
      case 'purple':
        return 'bg-violet-700';
      default:
        return '';
    }
  };

  const getTextColor = () => {
    switch (colorTheme) {
      case 'blue':
        return 'text-blue-50';
      case 'cyan':
        return 'text-cyan-100';
      case 'purple':
        return 'text-violet-100';
      default:
        return '';
    }
  };

  const getIconColor = () => {
    switch (colorTheme) {
      case 'blue':
        return 'text-blue-200';
      case 'cyan':
        return 'text-cyan-200';
      case 'purple':
        return 'text-violet-200';
      default:
        return '';
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="relative bg-gray-25 shadow-xl rounded-lg">
        <h2 className="sr-only">{form.hiddenTitle}</h2>

        <div className="grid grid-cols-1 lg:grid-cols-3">
          {/* Contact information */}
          <div
            className={`relative overflow-hidden py-10 px-6 rounded-t-lg sm:px-10 lg:rounded-l-lg lg:rounded-r-none xl:p-12 ${getBackgroundColor()}`}
          >
            <div
              className="absolute inset-0 pointer-events-none sm:hidden"
              aria-hidden="true"
            >
              <svg
                className="absolute inset-0 w-full h-full"
                width={343}
                height={388}
                viewBox="0 0 343 388"
                fill="none"
                preserveAspectRatio="xMidYMid slice"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M-99 461.107L608.107-246l707.103 707.107-707.103 707.103L-99 461.107z"
                  fill="url(#linear1)"
                  fillOpacity=".1"
                />
                <defs>
                  <linearGradient
                    id="linear1"
                    x1="254.553"
                    y1="107.554"
                    x2="961.66"
                    y2="814.66"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#fff" />
                    <stop offset={1} stopColor="#fff" stopOpacity={0} />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <div
              className="hidden absolute top-0 right-0 bottom-0 w-1/2 pointer-events-none sm:block lg:hidden"
              aria-hidden="true"
            >
              <svg
                className="absolute inset-0 w-full h-full"
                width={359}
                height={339}
                viewBox="0 0 359 339"
                fill="none"
                preserveAspectRatio="xMidYMid slice"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M-161 382.107L546.107-325l707.103 707.107-707.103 707.103L-161 382.107z"
                  fill="url(#linear2)"
                  fillOpacity=".1"
                />
                <defs>
                  <linearGradient
                    id="linear2"
                    x1="192.553"
                    y1="28.553"
                    x2="899.66"
                    y2="735.66"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#fff" />
                    <stop offset={1} stopColor="#fff" stopOpacity={0} />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <div
              className="hidden absolute top-0 right-0 bottom-0 w-1/2 pointer-events-none lg:block"
              aria-hidden="true"
            >
              <svg
                className="absolute inset-0 w-full h-full"
                width={160}
                height={678}
                viewBox="0 0 160 678"
                fill="none"
                preserveAspectRatio="xMidYMid slice"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M-161 679.107L546.107-28l707.103 707.107-707.103 707.103L-161 679.107z"
                  fill="url(#linear3)"
                  fillOpacity=".1"
                />
                <defs>
                  <linearGradient
                    id="linear3"
                    x1="192.553"
                    y1="325.553"
                    x2="899.66"
                    y2="1032.66"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#fff" />
                    <stop offset={1} stopColor="#fff" stopOpacity={0} />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <h3 className="text-lg font-semibold text-white">
              Contact information
            </h3>
            <p className={`mt-6 text-base max-w-3xl ${getTextColor()}`}>
              {form.description}
            </p>
            <dl className="mt-8 space-y-6">
              <dt>
                <span className="sr-only">Phone number</span>
              </dt>
              <dd className={`flex text-base ${getTextColor()}`}>
                <Icon
                  icon="mdi:phone"
                  className={`flex-shrink-0 w-6 h-6 ${getIconColor()}`}
                  aria-hidden="true"
                />
                <span className="ml-3">{form.phone}</span>
              </dd>
              <dt>
                <span className="sr-only">Email</span>
              </dt>
              <dd className={`flex text-base ${getTextColor()}`}>
                <Icon
                  icon="mdi:email"
                  className={`flex-shrink-0 w-6 h-6 ${getIconColor()}`}
                  aria-hidden="true"
                />
                <span className="ml-3">{form.email}</span>
              </dd>
            </dl>
            <ul className="mt-8 flex space-x-12">
              {form.socialMediaLinks.map(link => (
                <li key={`${link.name}-${link.url}`}>
                  <IconLink
                    name={link.name}
                    url={link.url}
                    icon={link.icon}
                    colorTheme={colorTheme}
                  />
                </li>
              ))}
            </ul>
          </div>

          {/* Contact form */}
          <div className="py-10 px-6 sm:px-10 lg:col-span-2 xl:p-12 bg-white">
            <h3 className="text-lg font-semibold text-base-content">
              Send us a message
            </h3>
            {pathname === '/schedule-demo/' ? (
              <iframe
                src="https://share.hsforms.com/1UO_vVyBXRRK4lEzxSbF3JQ36wtm"
                className="w-full min-h-[90vh]"
              />
            ) : (
              hubspotForm
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
